import {
    fillRange,
    minmax,
    niceScale,
    sum,
} from '../utility'

import {
    active,
    filters,
    homesBuilt,
    negative,
    positive,
} from '../changeRates'

import { project } from '../chart'

const YEARS_TO_PROJECT = 5
const Y_AXIS_SCALE_PADDING = 0.1

export default {
    props: {
        districtData: Object,
    },
    data: () => ({
        homesBuilt,
        filters,
    }),
    computed: {
        chart() {
            // Project with active filters
            const years = project(
                [...this.districtData.years],
                YEARS_TO_PROJECT,
                this.homesBuilt.value,
                active(this.filters),
            )

            // Project with all negative filters
            const minYears = project(
                [...this.districtData.years],
                YEARS_TO_PROJECT,
                homesBuilt.min,
                negative(this.filters),
            )

            // Project with all positive filters
            const maxYears = project(
                [...this.districtData.years],
                YEARS_TO_PROJECT,
                homesBuilt.max,
                positive(this.filters),
            )

            // Find the min and max of all enrollments
            const [min, max] = minmax([
                ...minYears.map((i) => sum(i.enrollments)),
                ...maxYears.map((i) => sum(i.enrollments)),
            ])

            // Pad the min and max to allow visual breathing room
            const pad = Math.floor(max - min) * Y_AXIS_SCALE_PADDING

            // Figure out a nice looking scale for y-axis
            const [lower, upper, increment] = niceScale(
                Math.max(0, Math.floor(min - pad)),
                Math.ceil(max + pad),
            )

            // Fill y-axis range
            const yAxis = fillRange(lower, upper, increment).reverse()

            // Fill x-axis values
            const xAxis = years.map(({
                year,
                enrollments,
                projection = false,
            }) => ({
                year,
                projection,
                total: sum(enrollments),
                percent: Math.round(((sum(enrollments) - lower) / (upper - lower)) * 100),
            }))

            return {
                xAxis,
                yAxis,
            }
        },
    },
    methods: {
        clear() {
            this.$emit('clear')
        },
    },
}
